interface MusicControllerOptions {
  playlist: string[];
  volume?: number;
  enabled?: boolean;
}

export class MusicController {
  private playlist: string[];
  private volume: number;
  private enabled: boolean;
  private currentIndex = 0;
  private currentAudio: HTMLAudioElement | null = null;
  private started = false;
  private paused = false;
  private playbackId = 0;

  constructor(options: MusicControllerOptions) {
    this.playlist = options.playlist;
    this.volume = options.volume ?? 0.4;
    this.enabled = options.enabled ?? true;
  }

  start(): void {
    if (!this.enabled || this.started || this.playlist.length === 0) {
      return;
    }
    this.started = true;
    this.paused = false;
    this.playCurrent();
  }

  stop(): void {
    this.started = false;
    this.paused = false;
    this.playbackId += 1;
    if (this.currentAudio) {
      this.currentAudio.onended = null;
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
    }
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) {
      this.stop();
    }
  }

  pause(): void {
    if (!this.started || this.paused) {
      return;
    }
    this.paused = true;
    if (this.currentAudio) {
      this.currentAudio.pause();
    }
  }

  resume(): void {
    if (!this.started || !this.paused) {
      return;
    }
    this.paused = false;
    if (this.currentAudio) {
      void this.currentAudio.play().catch(() => undefined);
      return;
    }
    this.playCurrent();
  }

  private playCurrent(): void {
    const src = this.playlist[this.currentIndex];
    if (!src) {
      return;
    }
    this.playbackId += 1;
    const playbackId = this.playbackId;
    if (this.currentAudio) {
      this.currentAudio.onended = null;
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    }
    const audio = new Audio(src);
    audio.volume = this.volume;
    audio.onended = () => {
      if (!this.started || this.paused || playbackId !== this.playbackId) {
        return;
      }
      this.currentIndex = (this.currentIndex + 1) % this.playlist.length;
      this.playCurrent();
    };
    this.currentAudio = audio;
    void audio.play().catch(() => undefined);
  }
}
